module.exports = __webpack_public_path__ + "media/images/countryrect/ir-80facb825159144fab4e84b7e4aa40d2.svg";